import axios from "axios";

const TRANSPORT_ERROR_CODES = new Set([
  "ERR_NETWORK",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ECONNRESET",
  "ECONNREFUSED",
  "ENOTFOUND",
  "EAI_AGAIN",
]);

export const isAxiosTransportError = (error: unknown): boolean =>
  axios.isAxiosError(error) &&
  error.response == null &&
  typeof error.code === "string" &&
  TRANSPORT_ERROR_CODES.has(error.code);
